import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartService } from '../cart.service';
import { NavController, LoadingController } from '@ionic/angular';
import { Commerce, ReqCommerce } from 'src/environments/environment';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-commerce',
  templateUrl: './commerce.page.html',
  styleUrls: ['./commerce.page.scss'],
})
export class CommercePage implements OnInit, OnDestroy {

  commerce = {} as Commerce;
  alergenos = false;

  constructor(
    public user: UserService,
    public route: ActivatedRoute,
    public stop: LoadingController,
    private rest: RestService,
    private nav: NavController,
    public service: CartService) {
      
    }

  ngOnInit() {
    this.service.user_id = this.route.snapshot.paramMap.get('id');
    this.getProducts();
  }

  switchTakeAway(event){
    if ( event.detail.value === '1' ){
      this.user.presentAlert('RECOGIDA EN LOCAL',this.commerce.take_away_message);
      this.service.take_away = 1;
    } else {
      this.service.take_away = 0;
    }
  }

  clickTakeAway(param){
    this.service.take_away = param;
  }

  toggleCat(cat){
    cat.toggle = !cat.toggle;
  }

  ngOnDestroy(){
    this.service.cart.length = 0;
    this.service.total = 0;
    this.service.discounts = 0;
    this.service.take_away = 0;
    this.service.totalOrders = 0;
    this.service.cupon = [];
  }

  viewAlergenos(){ this.alergenos = !this.alergenos; }

  addToCart(product){
    if (!this.user.isLoggedIn){
      this.GotoRegister();
    }else{
      this.service.pushService(product).then( () => {
        product.orders = 0;
        product.extras.forEach( e => e.added = 0);
      });
    }
  }

  displayButton(product){
    if ( product.orders > 0 ){
      product.orders = 0;
    } else {
      product.orders = 1;
    }
  }

  getProducts(){
    this.rest.ObtenerEstablecimiento(this.route.snapshot.paramMap.get('id') )
      .subscribe( (data: ReqCommerce) => {
        this.commerce = data.data;
        this.service.Commerce = data.data;
      });
  }

  addExtra(idCat, idProd, idEx){
    this.commerce.categories[idCat].products[idProd].extras[idEx].added += 1;
  }

  goToMenu(id){
    this.nav.navigateForward('/menu/'+id)
  }

  deleteExtra(idCat, idProd, idEx){
    if ( this.commerce.categories[idCat].products[idProd].extras[idEx].added > 0 ) {
      this.commerce.categories[idCat].products[idProd].extras[idEx].added -= 1;
    }
  }

  openExtras(product){
    if (product.open_extras === 0){
      product.open_extras = 1;
    }else{
      product.open_extras = 0;
    }
  }

  order(){
    this.nav.navigateForward('cart-orders/' + this.route.snapshot.paramMap.get('id'));
    this.rest.role = localStorage.getItem('commerce')
    this.service.delivery_price = this.commerce.delivery_price;
    this.service.delivery_min = this.commerce.delivery_min;
  }

  GotoRegister(){
    this.nav.navigateForward('/login');
  }


}
